import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { initialize } from '@fff-web/fff-analytics';
import Homepage from './pages/Homepage';
import NotFoundError from './pages/NotFoundError';
import SupplierDiversity from './pages/SupplierDiversity';
import './App.css';

function App() {
  // initializate analytics
  initialize();
  return (
    <HelmetProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/suppliers" element={<SupplierDiversity />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/" element={<Homepage />} />
            <Route path="/ff" element={<NotFoundError />} />
            <Route path="*" element={<NotFoundError />} />
          </Routes>
        </Router>
      </div>
    </HelmetProvider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LD_CLIENT_ID || '',
  options: { bootstrap: 'localStorage' },
  context: {
    kind: 'user',
    key: 'anonymous',
  },
})(App);
